import { initializeApp } from 'firebase/app';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';
import { getDatabase, connectDatabaseEmulator, goOffline } from 'firebase/database';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { requiredRuntimeValue } from '../config/runtime';


const firebaseConfig = {
    apiKey: requiredRuntimeValue("REACT_APP_FIREBASE_API_KEY"),
    authDomain: requiredRuntimeValue("REACT_APP_FIREBASE_AUTH_DOMAIN"),
    databaseURL: requiredRuntimeValue("REACT_APP_FIREBASE_DATABASE_URL"),
    projectId: requiredRuntimeValue("REACT_APP_FIREBASE_PROJECT_ID"),
    storageBucket: requiredRuntimeValue("REACT_APP_FIREBASE_STORAGE_BUCKET"),
    messagingSenderId: requiredRuntimeValue("REACT_APP_FIREBASE_MESSAGING_SENDER_ID"),
    appId: requiredRuntimeValue("REACT_APP_FIREBASE_APP_ID"),
};

const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const database = getDatabase(app)
export const functions = getFunctions(app);
if (process.env.REACT_APP_V2_E2E === 'true') goOffline(database);

if (process.env.REACT_APP_USE_EMULATORS === 'true') {
    if (!firebaseConfig.projectId.startsWith('demo-signet-') || !['localhost','127.0.0.1'].includes(window.location.hostname)) throw new Error('Emulators require a local demo-signet project');
    connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
    connectDatabaseEmulator(database, '127.0.0.1', 9000);
    connectStorageEmulator(storage, '127.0.0.1', 9199);
    connectFunctionsEmulator(functions, '127.0.0.1', 5001);
}
